import { apiAxios } from '@/api'

import { fetchWrapper } from '@/reducers/fetch'
import { updateYourTurnCount } from './conversation.slice'

export enum TICKET_TYPES {
  problem = 'problem',
  incident = 'incident',
  question = 'question',
  task = 'task',
}

export const POST_CREATE_TICKET_KEY = 'POST_CREATE_TICKET_KEY'
export const postCreateNewTicket = (payload: {
  comment: {
    body: string
    htmlBody: string
  }
  subject: string
  tags?: string[]
  type?: TICKET_TYPES
  ticketTopic?: string
  ticketTask?: string
}) =>
  fetchWrapper({
    fetchKey: POST_CREATE_TICKET_KEY,
    fetchFunction: async () => {
      const res = await apiAxios.post<{ message: string }>(
        '/finances/api/v1/zendesk/create',
        payload
      )

      return res.data
    },
  })

export const fetchUnreadMessageCount = () =>
  fetchWrapper({
    fetchFunction: async (dispatch) => {
      const json = await apiAxios.get<{ unreadMessageCount: number }>(
        '/finances/api/v1/zendesk/metadata'
      )

      dispatch(updateYourTurnCount(json.data.unreadMessageCount))
      return json.data
    },
    handleError: (dispatch) => dispatch(updateYourTurnCount(0)),
  })
